"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ShowSuccessMessageTimed = exports._ShowSuccessMessage = exports._ShowGloballyErrorMessageTimed = exports._ShowGloballyErrorMessage = exports._HideGloballyErrorMessage = exports._ShowGloballySuccessMessageTimed = exports._ShowGloballySuccessMessage = exports._HideSuccessMessage = exports._ScrollToFirstErrorField = exports._AddSuccessToFormField = exports._AddSuccessToDomObject = exports._AddToastMessage = exports._StatusFlagsOnObject = exports._RemoveAllStatusFlagsFromObject = exports._AddErrorToDomObject = exports._RemoveStatusFromDomObject = exports._RemoveStatusFromFormField = exports._RemoveSuccessFromFormField = exports._RemoveErrorFromFormField = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var css_injector_service_1 = require("../../services/css-injector.service");
var translation_1 = __importDefault(require("../../services/translation"));
var custom_dom_names_const_1 = require("../custom-dom-names.const");
var generator_const_1 = require("../dom-crud/generator.const");
var jquery_helper_const_1 = require("../dom-crud/jquery-helper.const");
var helper_const_1 = require("../helper.const");
var _RemoveErrorFromFormField = function (formField, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    $container.find(formField.uid).css('border', '').css('background', '');
    $container.find('#error-' + formField.uid.replace('#', '')).remove();
};
exports._RemoveErrorFromFormField = _RemoveErrorFromFormField;
var _RemoveSuccessFromFormField = function (formField, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    $container.find(formField.uid).css('border', '').css('background', '');
    $container.find('#success-' + formField.uid.replace('#', '')).remove();
};
exports._RemoveSuccessFromFormField = _RemoveSuccessFromFormField;
var _RemoveStatusFromFormField = function (formField, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    (0, exports._RemoveErrorFromFormField)(formField, $container);
    (0, exports._RemoveSuccessFromFormField)(formField, $container);
};
exports._RemoveStatusFromFormField = _RemoveStatusFromFormField;
/**
 *
 * @param domObject Input field we add message to
 */
var _RemoveStatusFromDomObject = function (domObject) {
    domObject.css('border', '').css('background', '');
    (0, exports._RemoveAllStatusFlagsFromObject)(domObject);
};
exports._RemoveStatusFromDomObject = _RemoveStatusFromDomObject;
var _AddErrorToDomObject = function (domObject, errorMessage) {
    console.log('adding error', errorMessage, 'to dom eleements', domObject);
    if (!domObject.length) {
        console.error('Error field doesnt exist', errorMessage, domObject);
        return;
    }
    (0, exports._RemoveStatusFromDomObject)(domObject);
    if ((0, jquery_helper_const_1._IsInput)(domObject)) {
        domObject.css('border', 'red 1px solid');
    }
    var error = (0, cash_dom_1.default)("<span \n            style=\"color:red\" \n            class=\"".concat(custom_dom_names_const_1._ClassNames.errorfield, "\" >\n          *").concat(translation_1.default.t(errorMessage) || translation_1.default.t('Dieses Feld ist erforderlich.'), "\n        </span>"));
    (0, exports._StatusFlagsOnObject)(domObject, error);
    domObject.after(error);
    return error;
};
exports._AddErrorToDomObject = _AddErrorToDomObject;
var _RemoveAllStatusFlagsFromObject = function (domObject) {
    var ele = domObject.get(0);
    if (ele === null || ele === void 0 ? void 0 : ele.statusElements) {
        for (var _i = 0, _a = ele.statusElements; _i < _a.length; _i++) {
            var entry = _a[_i];
            entry.remove();
        }
    }
};
exports._RemoveAllStatusFlagsFromObject = _RemoveAllStatusFlagsFromObject;
/**
 *
 * @param domObject
 * @param newStatus
 * @returns
 */
var _StatusFlagsOnObject = function (domObject, newStatus) {
    var ele = domObject.get(0);
    if (ele && !ele.statusElements) {
        ele.statusElements = [];
    }
    if (newStatus) {
        ele.statusElements.push(newStatus);
    }
    return ele.statusElements;
};
exports._StatusFlagsOnObject = _StatusFlagsOnObject;
var toasts = [];
var _AddToastMessage = function (domObject, message, settings) {
    if (domObject.length) {
        (0, css_injector_service_1._InjectCss)('_AddToastMessage', "\n      .".concat(custom_dom_names_const_1._ClassNames.toastmessage, "{\n        position: fixed;\n        width: 30%;\n        top: -50px;\n        left: 35%;\n        background-color: red;\n        height: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        z-index: 999;\n        overflow: hidden;\n        transition: all .2s;\n        animation: fittec-expand 0.2s ease-out 0.1s forwards;\n      }\n      @keyframes fittec-expand {\n        0% {\n          width: 0;\n          left: 35%;\n          height: 0;\n        }\n        100% {\n          width: 90%;\n          left: 5%;\n          height: 50px;\n        }\n      }\n    ") + ((settings === null || settings === void 0 ? void 0 : settings.cssOverwrite) || ''));
        var removeToast = function () {
            toast_1.css('top', '-55px');
            setTimeout(function () {
                toast_1.remove();
                toasts.splice(toasts.findIndex(function (a) { return a === toast_1; }), 1);
                toasts.forEach(function (a, index) {
                    a.css('top', index * 55 + 'px');
                });
            }, 200);
        };
        var toast_1 = (0, cash_dom_1.default)("<div class=\"".concat(custom_dom_names_const_1._ClassNames.toastmessage, "\" data-ref=\"fittec-toast-entry\">\n          <span>").concat(message || 'Dieses Feld ist erforderlich.', "</span>\n        </div>"));
        if (settings.closeable) {
            toast_1.append((0, cash_dom_1.default)("<span > X </span>").on('click', removeToast));
        }
        domObject.append(toast_1);
        toast_1.css('top', toasts.length * 55 + 'px');
        toasts.push(toast_1);
        if (settings === null || settings === void 0 ? void 0 : settings.timer) {
            setTimeout(removeToast, settings.timer);
        }
    }
    else {
        console.error('Error field doesnt exist', message, domObject);
    }
};
exports._AddToastMessage = _AddToastMessage;
var _AddSuccessToDomObject = function (domObject, successMessage) {
    var _a;
    if (domObject === void 0) { domObject = (0, cash_dom_1.default)('body'); }
    (0, exports._RemoveStatusFromDomObject)(domObject);
    if (successMessage === undefined || (successMessage === null || successMessage === void 0 ? void 0 : successMessage.length)) {
        var success = (0, cash_dom_1.default)("<span \n              style=\"color:#058405\" \n              class=\"".concat(custom_dom_names_const_1._ClassNames.successfield, "\">\n            ").concat((_a = translation_1.default.t(successMessage)) !== null && _a !== void 0 ? _a : '💪 Sieht gut aus!', " \n          </span>"));
        domObject.after(success);
        (0, exports._StatusFlagsOnObject)(success);
    }
    if ((0, jquery_helper_const_1._IsInput)(domObject)) {
        domObject
            .css('border', '#058405 2px solid')
            .css('background', '#c1e8c1')
            .css('background', '#222');
    }
};
exports._AddSuccessToDomObject = _AddSuccessToDomObject;
var _AddSuccessToFormField = function (formField, $container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    (0, exports._RemoveStatusFromFormField)(formField);
    $container.find(formField.uid).after((0, cash_dom_1.default)("<span \n            style=\"color:#058405\" \n            class=\"".concat(custom_dom_names_const_1._ClassNames.successfield, "\" \n            id=\"success-").concat(formField.uid.replace('#', ''), "\" \n            data-link=\"").concat(formField.uid, "\">\n          \uD83D\uDCAA Sieht gut aus!\n        </span>")));
    if ((0, jquery_helper_const_1._IsInput)($container.find(formField.uid))) {
        $container
            .find(formField.uid)
            .css('border', '#058405 2px solid')
            .css('background', '#c1e8c1');
    }
};
exports._AddSuccessToFormField = _AddSuccessToFormField;
var _ScrollToFirstErrorField = function ($container) {
    if ($container.find(".".concat(custom_dom_names_const_1._ClassNames.errorfield)).length) {
        var errorFields = $container.find(".".concat(custom_dom_names_const_1._ClassNames.errorfield));
        errorFields.each(function (index, errorField) {
            var element = (0, cash_dom_1.default)(errorField);
            if (jquery_helper_const_1._IsVisible && element) {
                console.log('SCROLL TO ', element);
                (0, helper_const_1._ScrollToPageElement)(element);
                return false;
            }
        });
    }
};
exports._ScrollToFirstErrorField = _ScrollToFirstErrorField;
// Function to hide the success message
var _HideSuccessMessage = function (successFieldId) {
    if (successFieldId === void 0) { successFieldId = 'success_msg'; }
    var successFieldObj = (0, cash_dom_1.default)('#' + successFieldId);
    successFieldObj.text('');
    successFieldObj.hide();
};
exports._HideSuccessMessage = _HideSuccessMessage;
// Function to show the success message
var _ShowGloballySuccessMessage = function (success, successFieldId) {
    if (successFieldId === void 0) { successFieldId = 'success_msg'; }
    var successFieldObj = (0, cash_dom_1.default)('#' + successFieldId);
    if (successFieldObj.length) {
        successFieldObj.text(translation_1.default.t(success));
        successFieldObj.show();
    }
    else {
        console.error('No success message field defined');
        successFieldObj = (0, generator_const_1._GetRow)({ html: translation_1.default.t(success) }, 'success', {
            id: successFieldId,
        });
        (0, jquery_helper_const_1._IsVisible)((0, cash_dom_1.default)('form')).prepend(successFieldObj);
    }
};
exports._ShowGloballySuccessMessage = _ShowGloballySuccessMessage;
// Function to show the success message temporarily
var _ShowGloballySuccessMessageTimed = function (success, milliseconds, successFieldId) {
    if (milliseconds === void 0) { milliseconds = 5000; }
    if (successFieldId === void 0) { successFieldId = 'success_msg'; }
    (0, exports._ShowGloballySuccessMessage)(success, successFieldId);
    setTimeout(function () { return (0, exports._HideSuccessMessage)(successFieldId); }, milliseconds);
};
exports._ShowGloballySuccessMessageTimed = _ShowGloballySuccessMessageTimed;
// Function to hide the error message
var _HideGloballyErrorMessage = function (errorFieldId) {
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    var errorFieldObj = (0, cash_dom_1.default)('#' + errorFieldId);
    errorFieldObj.text('');
    errorFieldObj.hide();
};
exports._HideGloballyErrorMessage = _HideGloballyErrorMessage;
// Function to show the error message
var _ShowGloballyErrorMessage = function (error, errorFieldId) {
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    var errorFieldObj = (0, cash_dom_1.default)('#' + errorFieldId);
    if (errorFieldObj.length) {
        errorFieldObj.text(translation_1.default.t(error));
        errorFieldObj.show();
    }
    else {
        console.error('No error message field defined so we added our own');
        errorFieldObj = (0, generator_const_1._GetRow)({ html: translation_1.default.t(error) }, 'error', {
            id: errorFieldId,
        });
        (0, jquery_helper_const_1._IsVisible)((0, cash_dom_1.default)('form')).prepend(errorFieldObj);
    }
    (0, helper_const_1._ScrollToPageElement)((0, cash_dom_1.default)('#' + errorFieldId), 120);
};
exports._ShowGloballyErrorMessage = _ShowGloballyErrorMessage;
// Function to show the error message temporarily
var _ShowGloballyErrorMessageTimed = function (error, milliseconds, errorFieldId) {
    if (milliseconds === void 0) { milliseconds = 5000; }
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    (0, exports._ShowGloballyErrorMessage)(error, errorFieldId);
    setTimeout(function () { return (0, exports._HideGloballyErrorMessage)(errorFieldId); }, milliseconds);
};
exports._ShowGloballyErrorMessageTimed = _ShowGloballyErrorMessageTimed;
var _ShowSuccessMessage = function (success, successFieldId) {
    var _a;
    if (successFieldId === void 0) { successFieldId = 'success_msg'; }
    var successFieldObj = (0, cash_dom_1.default)('#' + successFieldId);
    if (successFieldObj.length) {
        successFieldObj.text(translation_1.default.t(success));
        successFieldObj.show();
    }
    else {
        console.error('No success message field defined');
        successFieldObj = (0, generator_const_1._GetRow)({ html: success }, 'success', {
            id: successFieldId,
        });
        (_a = (0, jquery_helper_const_1._IsVisible)((0, cash_dom_1.default)('form'))) === null || _a === void 0 ? void 0 : _a.prepend(successFieldObj);
    }
};
exports._ShowSuccessMessage = _ShowSuccessMessage;
var _ShowSuccessMessageTimed = function (success, milliseconds, successFieldId) {
    if (milliseconds === void 0) { milliseconds = 5000; }
    if (successFieldId === void 0) { successFieldId = 'success_msg'; }
    (0, exports._ShowSuccessMessage)(success, successFieldId);
    setTimeout(function () { return (0, exports._HideSuccessMessage)(successFieldId); }, milliseconds);
};
exports._ShowSuccessMessageTimed = _ShowSuccessMessageTimed;
